function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "menu-24px");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("image", {
  id: "menu-24px",
  x: -4,
  y: -5,
  width: 28,
  height: 24,
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAYCAYAAADpnJ2CAAAAAXNSR0IArs4c6QAAAeBJREFUSA21lclOA0EMRBmWK0JCgv//PLhxZhn8PHmTSk9IJAKWPOX2Vt3uDkxXi0w7BLTF9EXaUXMOr7ZIaKapjROP+SkwBzvloOkugE/F1Tk2thF4XZp+bYrOiQSJX1XUZOBtdJBMQlCbGCIuq/13bVgubEiSaLUh9AQSiDcVkxBEzhHaGPwsBZW2PaGkIM0hUyU1xwaJ4wghU4hZ2yNlgUh2Pc/z2+K67DtN0311cDM0m3JU7kLfZWxL9WY6jtTmTVo7eyoHMZQixuuGytyIp/DePioD3dRImAFt0V16cvwp3hGPghzX1pO72hLiRLKZSYljThftPpk39lnzIMwggakezcuacYFRV/M4lK+PZvD/35ITMvOUuXb2XI67UuL+ATh1h9RzhygPhwfzXrrpPd5hJmCPWq6NWPNTrvEulNBknNoiu+aexYMGFJRkrraY8R5ZV+w+nVSP5jWdv7Xrah6qlp6reC/uBuQkfyX0yt49KkhT/aMtEsvf2LHNZFNIeDip+FrHOxxPyBoyJzH+ZivUQh7iiSR17Yb6DjN5KduPIU9H7Byhjfs0lc867YP/+AZt7Npx4j8nEiZ6yq7NZu5eX64l0udahEDRTlJi7beBSEBbTB/2KZGMHG2xfd9bUa5iLmCrRgAAAABJRU5ErkJggg=="
}));

var SvgMenu = function SvgMenu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "14px",
    viewBox: "0 0 20 14",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu.1146804b.svg";
export { ForwardRef as ReactComponent };